import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    car: Yup.object().nullable().required('Please select a vehicle'),
    contractTerm: Yup.object()
        .nullable()
        .required('Please select a contract term'),
    annualMileage: Yup.object()
        .nullable()
        .required('Please select annual mileage'),
    fullName: Yup.string()
        .min(2, 'Full name must be at least 2 characters')
        .max(100, 'Full name must be less than 100 characters')
        .required('Full name is required'),
    emailAddress: Yup.string()
        .email('Invalid email format')
        .required('Email address is required'),
    phoneNumber: Yup.string()
        .matches(
            /^[0-9+\-\s()]+$/,
            'Invalid phone number format. Only numbers, spaces, +, -, and () are allowed'
        )
        .min(10, 'Phone number must be at least 10 digits')
        .max(20, 'Phone number must be less than 20 characters')
        .required('Phone number is required'),
    housePostcode: Yup.string().required('Postcode is required'),
    occupation: Yup.string().max(
        100,
        'Occupation must be less than 100 characters'
    ),
    dateOfBirth: Yup.string().required('Date of birth is required'),
    dobDay: Yup.string()
        .length(2, 'Incorrect length')
        .matches(/^[0-9]*$/, 'Please enter a number')
        .test(
            'number of days in february',
            'Incorrect number of days in february',
            (value, context) => {
                return context.parent.dobMonth !== undefined
                    ? context.parent.dobMonth === '02'
                        ? Number(value) <= 29
                        : Number(value) <= 31
                    : Number(value) <= 31;
            }
        )
        .test(
            'number of days in months not equal to 30',
            'Incorrect number of days in months not equal to 30',
            (value, context) =>
                context.parent.dobMonth === undefined
                    ? true
                    : context.parent.dobMonth !== undefined
                      ? (context.parent.dobMonth === '01' ||
                            context.parent.dobMonth === '03' ||
                            context.parent.dobMonth === '05' ||
                            context.parent.dobMonth === '07' ||
                            context.parent.dobMonth === '08' ||
                            context.parent.dobMonth === '10' ||
                            context.parent.dobMonth === '12') &&
                        Number(value) <= 31
                          ? true
                          : Number(value) <= 30
                      : Number(value) <= 30
        )
        .test(
            'number of days in months not equal to 31',
            'Incorrect number of days in months not equal to 31',
            (value, context) =>
                context.parent.dobMonth === undefined
                    ? true
                    : context.parent.dobMonth !== undefined
                      ? (context.parent.dobMonth === '04' ||
                            context.parent.dobMonth === '06' ||
                            context.parent.dobMonth === '09' ||
                            context.parent.dobMonth === '11') &&
                        Number(value) <= 30
                          ? true
                          : Number(value) <= 31
                      : Number(value) <= 30
        )
        .required('Required'),
    dobMonth: Yup.string()
        .length(2, 'Incorrect length')
        .test(
            'number of months',
            'Incorrect number of months',
            (value) => Number(value) <= 12
        )
        .required('Required'),
    dobYear: Yup.string().length(4, 'Incorrect length').required('Required'),
});

export default validationSchema;
